import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface ReportMarkdownProps {
  content: string;
  className?: string;
}

const ReportMarkdown: React.FC<ReportMarkdownProps> = ({ content, className = "" }) => {
  if (!content.trim()) {return null;}

  return (
    <ReactMarkdown
      className={`report-markdown ${className}`.trim()}
      remarkPlugins={[remarkGfm]}
      linkTarget="_blank"
      components={{
        a: ({ href, children }) => (
          <a href={href} target="_blank" rel="noopener noreferrer" className="report-markdown-link">
            {children}
          </a>
        ),
        p: ({ children }) => <p className="report-markdown-paragraph">{children}</p>,
        ul: ({ children }) => <ul className="report-markdown-list">{children}</ul>,
        ol: ({ children }) => <ol className="report-markdown-list">{children}</ol>,
        li: ({ children }) => <li className="report-markdown-list-item">{children}</li>,
        h1: ({ children }) => <h4 className="report-markdown-heading">{children}</h4>,
        h2: ({ children }) => <h4 className="report-markdown-heading">{children}</h4>,
        h3: ({ children }) => <h4 className="report-markdown-heading">{children}</h4>,
      }}
    >
      {content}
    </ReactMarkdown>
  );
};

export default ReportMarkdown;
